export const viRegExp = /^.*(vimeo.com\/)([0-9]{3,99}).*/;

export function getVideoId(url) {
  const match = url.match(viRegExp);

  return match[2]; // id
}
export function getEmbedUrlVimeo(rawUrl) {
  const id = getVideoId(rawUrl);

  return `${location.protocol}//player.vimeo.com/video/${id}?controls=0`;
}
